import React, { Fragment } from 'react';
import moment from 'moment';
import { Paper, Grid } from '@material-ui/core';
import { DialWidgetCard } from '../../Elements';
import { displayDateFormatShort } from '../../../constants';
import FbvProjection from './FbvProjection';

const BvFbvOutput = ({ prevMntCond, logResult, maxYear, minYear }) => {
  const hasFuture = logResult.future_value && Object.keys(logResult.future_value).length;

  return (
    <Fragment>
      <div className="bv-fbv-output engine-valuation-output">
        {hasFuture ? (
          <Paper className="output-fbv-card engine-projection-header">
            <div>
              <h4>Future Projection Values</h4>
              <p>Projection Till: <span>{moment(logResult.projection_to).format(displayDateFormatShort)}</span></p>
            </div>
            <div className="engine-output-actions">
              <FbvProjection prevMntCond={prevMntCond} logResult={logResult} maxYear={maxYear} minYear={minYear} />
            </div>
          </Paper>
        ) : null}

        <p className="engine-value-as-of">Value as of: {moment(logResult.base_value_date).format(displayDateFormatShort)}</p>

        <Paper className="output-widget-card engine-result-card">
          <Grid container spacing={1}>
            {prevMntCond != 1 ? (
              <Grid item md={prevMntCond == 2 ? 6 : 12} xs={12}>
                <DialWidgetCard value={`${logResult.base_value.toFixed(3)}`} label="Half Life" unit="m" />
              </Grid>
            ) : null}
            {prevMntCond != 0 ? (
              <Grid item md={prevMntCond == 2 ? 6 : 12} xs={12}>
                <DialWidgetCard value={`${logResult.full_life_base_value ? logResult.full_life_base_value.toFixed(3) : 0}`} label="Full Life" unit="m" />
              </Grid>
            ) : null}
          </Grid>
          <h4 className="engine-card-caption">Current Base Value</h4>
        </Paper>

        <Paper className="output-widget-card engine-result-card">
          <Grid container spacing={1}>
            {prevMntCond != 1 ? (
              <Grid item md={prevMntCond == 2 ? 6 : 12} xs={12}>
                <DialWidgetCard value={`${logResult.cmv_value.toFixed(3)}`} label="Half Life" unit="m" />
              </Grid>
            ) : null}
            {prevMntCond != 0 ? (
              <Grid item md={prevMntCond == 2 ? 6 : 12} xs={12}>
                <DialWidgetCard value={`${logResult.full_life_cmv_value ? logResult.full_life_cmv_value.toFixed(3) : 0}`} label="Full Life" unit="m" />
              </Grid>
            ) : null}
          </Grid>
          <h4 className="engine-card-caption">Current Market Value</h4>
        </Paper>

        {logResult.full_life_cmv_base_value ? (
          <Paper className="output-widget-card engine-result-card">
            <Grid container spacing={1}>
              <Grid item md={12} xs={12}>
                <DialWidgetCard value={`${logResult.full_life_cmv_base_value.toFixed(3)}`} label="" unit="" show_dollar="" />
              </Grid>
            </Grid>
            <h4 className="engine-card-caption">Full Life CMV/Full Life BV</h4>
          </Paper>
        ) : null}
      </div>
    </Fragment>
  );
};

export default BvFbvOutput;
